module.exports = __webpack_public_path__ + "img/643db6a.png";